import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-sport-list',
  template: `
  <app-m-sport-list *ngIf="env.isMobile"></app-m-sport-list>
  <app-d-sport-list *ngIf="!env.isMobile"></app-d-sport-list>
  `,
  styles: []
})
export class SportListComponent extends BaseClass<any> implements OnInit {
  public odds: any;
  public id = '';
  public eId = '';
  public marketsReq: any[] = [];
  public datalength: any = 0;

  constructor(
    public service: WebserviceService,
    public actRoute: ActivatedRoute
  ) { super(document); }

  ngOnInit(): void {
    this.getUserData();
  }

  getUserData() {
    if (this.isLogin()) {
      this.userData = this.getLocalItem('user');
      this.webSocketUrl = this.getLocalItem('ws', false);
      if (this.webSocketUrl) {
        this.getServices().Get(`${this.webSocketUrl + this.api.userData}/${this.userData?.id}`).subscribe(
          (res) => {
            if (res) {
              this.userData.balance = res.balance;
              this.userData.pl = res.pl;
              this.userData.available_balance = parseFloat(res.pl) + parseFloat(res.balance) + parseFloat(res.expose);
              this.userData.expose = res.expose;
              this.setLocalItem('user', this.userData);
              this.userData = this.getLocalItem('user');
            }
          },
          (err) => {
            console.log(err);
          });
      }
    }
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  listByTypeId(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    let dt = grouped.get(id) ? grouped.get(id) : [];
    return [{ name: '', data: dt }];
  }

  listByinPlay(items: any) {
    let dt = items.filter((s: any) => !this.events.races.includes(s?.event_type_id));
    return [{ name: '', data: dt }];
    // const grouped = this.groupBy(items, (dat: any) => dat.in_play);
    // return grouped.get(1) ? grouped.get(1) : [];
  }

  listByTypeIdCat(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    let dt = grouped.get(id) ? grouped.get(id) : [];
    return this.genCompetitionWiseData(dt);
  }

  listByinPlayCat(items: any) {
    let dt = items.filter((s: any) => !this.events.races.includes(s?.event_type_id));
    return this.genCompetitionWiseData(dt);
    // const grouped = this.groupBy(items, (dat: any) => dat.in_play);
    // return grouped.get(1) ? grouped.get(1) : [];
  }

  listByTypeIdData(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    return grouped.get(id) ? grouped.get(id) : [];
  }

  listByinPlayData(items: any) {
    return items.filter((s: any) => !this.events.races.includes(s?.event_type_id));
  }

  reArrangeRaceData(items: any, id: any) {
    items = this.listByTypeIdData(items, id);

    let rc = items.map((a: any) => (a.event_country_code));
    const uniqueSet1 = new Set(rc);
    rc = [...uniqueSet1];
    rc = rc.map((a: any) => ({ race: '', event_country_code: a, data: [] }));
    const grouped = this.groupBy(items, (dat: any) => dat.event_country_code);

    rc.forEach((element: any) => {
      let dt = grouped.get(element.event_country_code) ? grouped.get(element.event_country_code) : [];
      let rcd = dt.map((a: any) => (a.event_id));
      const uniqueSet1 = new Set(rcd);
      rcd = [...uniqueSet1];
      rcd = rcd.map((a: any) => ({ event_id: a, event_name: '', data: [] }));
      const groupedByEvent = this.groupBy(dt, (dat: any) => dat.event_id);

      rcd.forEach((eEle: any) => {
        eEle.data = [...eEle.data, ...groupedByEvent.get(eEle.event_id) ? groupedByEvent.get(eEle.event_id) : []]
        eEle.event_name = eEle.data[0]?.event_name;
      });

      element.data = rcd
    });

    return rc;
  }

  genCompetitionWiseData(e: any) {
    let dataByCat: any[] = [];
    if (e.length > 0) {
      let ids: any[] = [];
      e.forEach((tdt: any) => {
        ids.push({ id: tdt.competition_id, name: tdt.competition_name });
      });
      ids = [... new Set(ids.map(JSON.stringify as any))].map(JSON.parse as any)
      const grouped = this.groupBy(e, (dat: any) => dat.competition_id);
      ids.forEach((ele) => {
        if (grouped.get(ele.id)) {
          let eventTypeIds = grouped.get(ele.id).map((emp: any) => { return emp.event_type_id });
          dataByCat.push({ name: ele.name, data: grouped.get(ele.id), eTypeIds: eventTypeIds })
        }
      });
    }
    return dataByCat;
  }

}
